import type { GridColDef } from '@mui/x-data-grid';

import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { dateUtils } from '@/utils/date';

export const columns = (): GridColDef[] => [
    {
        field: 'code',
        headerName: 'Mã',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: (params: any) => <HoverCopyCell value={params.row.code} />,
    },
    {
        field: 'name',
        headerName: 'Tên loại thành phần',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: (params: any) => <HoverCopyCell value={params.row.name} />,
    },
    {
        field: 'partCategoryCode',
        headerName: 'Tên danh mục thành phần',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: (params: any) => (
            <HoverCopyCell value={params.row.partCategory?.name} />
        ),
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        editable: false,
        sortable: true,
        minWidth: 150,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell
                value={
                    params.row.createdDate
                        ? dateUtils.getDate(params.row.createdDate)
                        : '-:-'
                }
            />
        ),
    },
    {
        field: 'description',
        headerName: 'Mô tả',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: (params: any) => (
            <HoverCopyCell value={params.row.description} />
        ),
    },
];
